import { Component } from '@angular/core'
import { isNotNullable, WindowRef } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { filter, map } from 'rxjs/operators'

@Component({
  selector: 'mb-pdp-infobox-details-nonantibody',
  templateUrl: './pdp-infobox-details-nonantibody.component.html',
  styleUrls: ['./pdp-infobox-details-nonantibody.component.scss']
})
export class PdpInfoBoxDetailsNonAntibodyComponent {

  product$ = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
  )
  getOverviewText$ = this.product$.pipe(
    filter(product => !Boolean(product.isAntibody)),
    map(product => product?.description)
  )

  constructor (private currentProductService: CurrentProductService,
               private winRef: WindowRef) {
  }

  scrollToSpecsTab () {
    const specificationsTabButton = this.winRef.document.querySelector('button[data-cy="mb-pdp-tab-title-specifications"]') as HTMLElement
    const navigationButton = this.winRef.document.querySelector('nav[data-cy="navigation"]') as HTMLElement
    if (!specificationsTabButton.classList.contains('active')) {
      specificationsTabButton.click()
    }
    this.winRef?.nativeWindow?.scroll({
      top: specificationsTabButton.offsetTop - (navigationButton.offsetHeight + specificationsTabButton.offsetHeight),
      behavior: 'smooth'
    })
  }
}
